// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__gAaYO","loader":"MediumLoader_loader__D5qTt","spinner-c7wet2":"MediumLoader_spinner-c7wet2__C7BXO"};